import React from 'react';
export const FieldSetContext = React.createContext({
    status: null,
    statusId: null,
});
//# sourceMappingURL=FieldSet.context.js.map